import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaCheckCircle } from 'react-icons/fa';
import CustomButton from '../CustomButton';
import './SuccessModal.css';

const SuccessModal = ({ show, onClose, title, description }) => {
  return (
    <Modal show={show} onHide={onClose} centered className="success-modal">
      <Modal.Body className="text-center p-4">
        <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        <div className="success-icon mt-5 mb-3">
          <FaCheckCircle size={48} className="text-success" />
        </div>
        <h4 className="success-modal-title mb-3">{title}</h4>
        <p className="success-modal-text mb-4">{description}</p>
        <CustomButton
          text="OK"
          onClick={onClose}
          className="success-modal-btn"
        />
      </Modal.Body>
    </Modal>
  );
};

export default SuccessModal;
